'use client';

import { Checkbox, Skeleton } from '@common/components';

interface FilterCheckboxListProps<T extends string | number> {
  options: { value: T; label: string }[];
  selectedValues: T[];
  onToggle: (value: T) => void;
  emptyLabel?: string;
  isLoading?: boolean;
  skeletonCount?: number;
}

export function FilterCheckboxList<T extends string | number>({
  options,
  selectedValues,
  onToggle,
  emptyLabel = '선택 가능한 항목이 없습니다.',
  isLoading = false,
  skeletonCount = 5,
}: FilterCheckboxListProps<T>) {
  if (isLoading) {
    /* 실제 <Checkbox label>: `flex items-start gap-4 p-4`
     * - box: `m-2 size-16` (effective 20×20)
     * - text: typo-body4 line-height 1.5 × 14 = 21
     * row 높이 = max(20, 21) + p-4(8) = 29px */
    return (
      <>
        {Array.from({ length: skeletonCount }, (_, index) => (
          <div key={index} className="flex items-start gap-4 p-4">
            <Skeleton className="m-2 size-16 shrink-0 rounded-xxsmall" />
            <Skeleton className="h-21 w-3/5 rounded-xxsmall" />
          </div>
        ))}
      </>
    );
  }

  if (options.length < 1) {
    return <p className="text-Gray-550 typo-body4">{emptyLabel}</p>;
  }

  return (
    <>
      {options.map((option) => (
        <Checkbox
          key={String(option.value)}
          checked={selectedValues.includes(option.value)}
          onCheckedChange={() => onToggle(option.value)}
        >
          <span className="tracking-[-0.28px] text-Gray-800 typo-body4">
            {option.label}
          </span>
        </Checkbox>
      ))}
    </>
  );
}
